<form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">

  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{ modalTitle }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">

      <!-- Package -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Package Name</label>
        </div>

        <div class="form-group col-sm-8">
        <input type="text" class="form-control" formControlName="package"
          [ngClass]="formErrorClass(createForm.controls.package, createFormSubmitted)">
        </div>          
        <span class="text-danger"
          *ngIf="(createForm.controls.package?.touched || createFormSubmitted) && createForm.controls.package?.errors?.required">
          This field is required.
        </span>
        
      </div>


      <!-- TimeTable -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Timetable</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="timetable">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="timetable_value">
        </div>
      </div>

      <!-- Servicing -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Servicing </label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="servicing">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="servicing_value">
        </div>
      </div>

      <!-- Human Resources  -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Human Resources </label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="human_resource">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="human_resource_value">
        </div>
      </div>
      
      <!-- Mesurement Tool -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Mesurement Tool</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="mesurement_tool">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="mesurement_tool_value">
        </div>
      </div>

      <!-- problem_solving -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Problem Solving</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="problem_solving">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="probsolve_value">
        </div>
      </div>
      
      <!-- doc_management -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Doc Management</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="doc_management">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="docmang_value">
        </div>
      </div>

      <!-- clients -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Clients</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="clients">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="clients_value">
        </div>
      </div>
      
      <!-- consultancy -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Consultancy</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="consultancy">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="consultancy_value">
        </div>
      </div>

      <!-- academy -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Academy</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="academy">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="academy_value">
        </div>
      </div>
      
      <!-- project -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Project</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="project">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="project_value">
        </div>
      </div>

      <!-- audit -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label for="first-name">Audit</label>
        </div>        
        <div class="form-group col-sm-4">
          <mat-slide-toggle class="example-margin" formControlName="audit">
          </mat-slide-toggle>
        </div>
        <div class="form-group col-sm-4">
          <input type="text" class="form-control" formControlName="audit_value">
        </div>
      </div>      

      <div class="form-group col-sm-6">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>


    </div>
  </div>


</form>